/**
 * prd2 lobby — ~70 BPM soft synth bed (no external assets). Starts after first
 * pointer in lobby; dispose when entering the game.
 */
export class LobbyAmbient {
  private ctx: AudioContext | null = null;
  private oscA: OscillatorNode | null = null;
  private oscB: OscillatorNode | null = null;
  private beatTimer: ReturnType<typeof setInterval> | null = null;

  constructor() {
    const kick = () => this.ensure();
    window.addEventListener('pointerdown', kick, { once: true });
    window.addEventListener('keydown', kick, { once: true });
  }

  ensure(): void {
    // Disabled - no ambient sound on lobby/name entry screen
    return;
  }

  dispose(): void {
    if (this.beatTimer) {
      clearInterval(this.beatTimer);
      this.beatTimer = null;
    }
    try {
      this.oscA?.stop();
      this.oscB?.stop();
    } catch {
      /* ignore */
    }
    this.oscA = null;
    this.oscB = null;
    void this.ctx?.close();
    this.ctx = null;
  }
}
